const uri = window.location.origin;

export const initClientAccount = async (userConsent,country, docType, access_token, session_token) => {
  return fetch(`${uri}/backend-vald/initialize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    },
    body: JSON.stringify({
      userConsent: userConsent,
      country: country,
      docType: docType})
  });
}

export const initCallbackForAccount = async (accountId, workflowExecutionId, access_token, session_token) => {
  return fetch(`${uri}/backend-vald/initiate-callback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    },
    body: JSON.stringify({
      accountId: accountId,
      workflowExecutionId: workflowExecutionId
    })
  });
}

export const fetchClientLogo = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/client/logo`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
};

export const fetchProfileConfiguration = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/client/whitelabel`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
};

export const fetchProfilePalette = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/profile/palette`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
};

export const fetchDecodedSessionToken = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/client/decode`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
}

export const accountValidation = async (access_token, session_token) => {
  try {
    const response = await fetch(`${uri}/backend-vald/validation`, {
      method: 'POST',
      headers: {
        'Authorization': 'bearer ' + access_token,
        'SessionToken': session_token,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    return JSON.parse(result);
  } catch (error) {
    console.error('Error during account validation:', error);
    throw error;
  }
};

export const microdepositsVerification = async (access_token, session_token, firstDeposit, secondDeposit) => {
  const transactions = [
    { "context": "ACCOUNT_VALIDATION", "amount": {"amount": firstDeposit, "currency": "EUR" }},
    { "context": "ACCOUNT_VALIDATION", "amount": {"amount": secondDeposit, "currency": "EUR" }}
  ];
  try {
    const response = await fetch(`${uri}/backend-vald/validation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + access_token,
        'SessionToken': session_token,
      },
      body: JSON.stringify(transactions)
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    const responseCollections = JSON.parse(result);

    return responseCollections;
  } catch (error) {
    console.error('Error during account validation:', error);
    throw error;
  }
};

export const aisConsent = async (access_token, session_token, locale) => {
  try {
    const response = await fetch(`${uri}/backend-vald/consent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + access_token,
        'SessionToken': session_token,
        'Locale': locale
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok for consent init');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    const consentResponse = JSON.parse(result);

    return consentResponse;
  } catch (error) {
    console.error('Error during consent init:', error);
    throw error;
  }
}

export const aisAccount = async (access_token, session_token, consentId) => {
  try {
    const response = await fetch(`${uri}/backend-vald/account`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + access_token,
        'SessionToken': session_token,
        'ConsentId': consentId
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok for consent init');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    const accountResponse = JSON.parse(result);

    return accountResponse;
  } catch (error) {
    console.error('Error during ais account init:', error);
    throw error;
  }
}

export const aisLoaded = async (access_token, session_token) => {
  const response = await fetch(`${uri}/backend-vald/ais/loaded`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token
    }
  });

  if (!response.ok) {
    throw new Error('Network response was not ok for ais loaded signal');
  }

  return response;
}

export const microdepositLoaded = async (access_token, session_token) => {
  const response = await fetch(`${uri}/backend-vald/microdeposit/loaded`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token
    }
  });

  if (!response.ok) {
    throw new Error('Network response was not ok for microdeposit loaded signal');
  }

  // Return the promoted MICRODEPOSIT session state so the caller can adopt the fresh
  // effectiveExpiresAt produced by the AVS->MICRODEPOSIT promotion (the rolling inactivity
  // window), rather than the stale token-cap expiry carried over from the deferred AVS poll.
  const body = await response.text();
  return body ? JSON.parse(body) : null;
}

export const validationFallback = async (access_token, session_token, code, description, provider, terminalState) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
      'Code': code,
      'Description': description,
      'Provider': provider
    };
    if (terminalState) {
      headers['TerminalState'] = terminalState;
    }
    const response = await fetch(`${uri}/backend-vald/fallback`, {
      method: 'POST',
      headers
    });

    if (!response.ok) {
      throw new Error('Network response was not ok for ais error init');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    return JSON.parse(result);
  } catch (error) {
    console.error('Error during fallback response init:', error);
    throw error;
  }
}

export const fetchProfileComponents = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/profile/components`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
};

export const fetchProfileAccountRegion = async (access_token, session_token) => {
  return fetch(`${uri}/backend-vald/profile/account-region`, {
    method: 'GET',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    }
  });
};

export const notifyRedirect = async (access_token, session_token, outcome) => {
  const endpoint = outcome
    ? `${uri}/backend-vald/validation/redirect?outcome=${encodeURIComponent(outcome)}`
    : `${uri}/backend-vald/validation/redirect`;
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Authorization': 'bearer ' + access_token,
      'SessionToken': session_token,
    },
    keepalive: true,
  });
};

export const sessionStatus = async (access_token, session_token) => {
  try {
    const response = await fetch(`${uri}/backend-vald/session-status`, {
      method: 'POST',
      headers: {
        'Authorization': 'bearer ' + access_token,
        'SessionToken': session_token,
      },
    });

    if (response.status === 204) {
      return null;
    }

    if (!response.ok) {
      throw new Error('Network response was not ok for session status');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let result = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    return JSON.parse(result);
  } catch (error) {
    console.error('Error during session status check:', error);
    return null;
  }
};
